// @ts-nocheck
import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { FileText, Download, Loader2 } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { invokeEdgeFunction } from "@/lib/invokeEdgeFunction";

interface PacketData {
  id: string;
  packet_price_cents: number;
  packet_file_url?: string;
}

interface PurchasePacketsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  packet: PacketData | null;
  eventId: string;
  eventName?: string;
}

const PurchasePacketsModal: React.FC<PurchasePacketsModalProps> = ({
  open,
  onOpenChange,
  packet,
  eventId,
  eventName
}) => {
  const [loading, setLoading] = useState(false);

  const handlePurchase = async () => {
    if (!packet) return;
    
    setLoading(true);
    try {
      const { data, error } = await invokeEdgeFunction('stripe-packet-checkout', {
        body: {
          packet_id: packet.id,
          event_id: eventId,
          success_url: `${window.location.origin}/packet-purchase-success?session_id={CHECKOUT_SESSION_ID}`,
          cancel_url: window.location.href
        }
      });

      if (error) throw error;

      if (data?.checkout_url) {
        window.location.href = data.checkout_url;
      } else {
        throw new Error('No checkout URL received');
      }
    } catch (err: any) {
      console.error('Purchase error:', err);
      toast.error(err.message || 'Failed to start checkout');
    } finally {
      setLoading(false);
    }
  };

  if (!packet) return null;

  const priceDisplay = (packet.packet_price_cents / 100).toFixed(2);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <FileText className="w-5 h-5 text-primary" />
            Coach Packet
          </DialogTitle>
          <DialogDescription>
            {eventName ? `Get the complete roster packet for ${eventName}` : 'Get the complete event roster packet'}
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="bg-muted/50 rounded-lg p-4">
            <h4 className="font-medium mb-2">What's included:</h4>
            <ul className="text-sm text-muted-foreground space-y-1">
              <li>• Complete player roster with profiles</li>
              <li>• Contact information for coaches</li>
              <li>• Athletic stats and highlights</li>
              <li>• Downloadable PDF format</li>
            </ul>
          </div>
          
          <div className="flex items-center justify-between p-4 border rounded-lg">
            <span className="font-medium">Event Roster Packet</span>
            <span className="text-lg font-bold text-primary">${priceDisplay}</span>
          </div>
        </div>
        
        <div className="flex gap-3">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="flex-1"
          >
            Cancel
          </Button>
          <Button
            onClick={handlePurchase}
            disabled={loading}
            className="flex-1"
          >
            {loading ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                Processing...
              </>
            ) : (
              <>
                <Download className="w-4 h-4 mr-2" />
                Purchase - ${priceDisplay}
              </>
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PurchasePacketsModal;